/* eslint-disable */
import React from 'react';
import { Link, Typography } from '@one-thd/sui-atomic-components';
import { Carousel } from '@one-thd/sui-carousel';
import { shape as shapeType, string as stringType, arrayOf as arrayOfType} from 'prop-types';
import { cleanHtml } from '../../CollectionHelpers';

export const BathHeroCarousel = React.memo(({
  heroBannerSlides, collectionName, brandName
}) => {
  return (
    <>
      <div className="sui-pb-4 sui-pt-10">
        <Typography variant="h1" weight="display">
          {collectionName} By {brandName}
        </Typography>
      </div>
      <Carousel
        type="hero"
        disableShadow
        hideControls={heroBannerSlides?.length === 1}
        title=""
      >
        {heroBannerSlides.map(({ title, brand, image, description }, index) => (
          <div
            key={`hero-collection-image-${index}`}
            className="sui-h-full md:sui-max-h-[440px]"
          >
            <div className="sui-relative sui-flex sui-h-full">
              <div className={`sui-bg-white sui-border-1 sui-border-solid
              sui-border-[#CCCCCB] box-border
                sui-rounded-[0.2rem] sui-m-0 sui-p-0 sui-overflow-hidden
                sui-flex sui-flex-col md:sui-flex-row
                sui-justify-between sui-w-full`}
              >
                <div className={`sui-flex sui-border-b-1 sui-border-b-solid sui-border-b-[#CCCCCB]
                  md:sui-sui-border-l-1 md:sui-border-l-solid md:sui-border-l-[#CCCCCB] md:sui-border-b-0 sui-shrink-0
                  md:sui-aspect-square lg:sui-aspect-video md:sui-w-[55%] lg:sui-w-3/5 xl:sui-w-7/12 2xl:sui-w-[55%]
                  sui-max-h-[275px] md:sui-max-h-[440px]`}
                >
                  <img
                    src={image}
                    alt={title}
                    title={`Image for ${title}`}
                    height={900}
                    width={1440}
                    className="sui-aspect-[inherit] sui-object-cover"
                    // eslint-disable-next-line react/no-unknown-property
                    fetchpriority="high"
                  />
                </div>
                <div className={`sui-flex sui-flex-col sui-justify-center
                  sui-h-full sui-relative sui-p-4 sui-overflow-y-hidden
                  lg:sui-p-10 md:sui-min-h-[374px]
                  lg:sui-min-h-[384px] xl:sui-min-h-[400px]`}
                >
                  <div className="sui-w-full xl:sui-w-[85%]">
                  <div className="sui-my-2">
                    <Typography color="brand" variant="h4">{brand}</Typography>
                  </div>
                    {title && (
                      <Typography
                        height="none"
                        weight="display"
                        variant="h2"
                        color="primary"
                      >{title}
                      </Typography>
                    )}
                    {description && (
                      <div className="sui-my-4">
                        <Typography
                          color="subtle"
                          component="div"
                          dangerouslySetInnerHTML={cleanHtml(description)}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </>
  );
});

BathHeroCarousel.propTypes = {
  heroBannerSlides: arrayOfType(shapeType({
    title: stringType,
    brand: stringType,
    description: stringType,
    image: stringType
  })).isRequired,
  collectionName: stringType,
  brandName: stringType
};
